module.exports = __webpack_public_path__ + "img/konyvajanlo_2.d2d300af.jpg";